import api from '../services/api'

import env from '../services/environnement'

import Vue from 'vue';
import { mergePresence } from '../components/chat/presence';

import router, { resetRouter } from "../services/customRouter.js";

const getUser = {
    state: {

        user: { nickname: '', companie: '', iduser: '', email: '', imgSrc: '', preferences: {} },
        profils: [],

        isAuth: false,
        isPublic : false,
        systemLoad: false,
        defaultPage: {},
        connectedUsers: [],
        presenceSources: {},
        notifications : [],
        inactivState : false,
    },

    getters: {

        currentUser: (state) => {
            return state.user
        },

        listProfils: (state) => {
            return state.profils
        },

        isAuth: (state) => {
            return state.isAuth
        },

        isPublic: (state) => (type) => {
            return (state.isPublic==false || (state.isPublic!==false && state.isPublic[type] === true))
        },
        publicParams: (state) => (type) => {
            return state.isPublic[type]
        },

        systemLoad: (state) => {
            return state.systemLoad
        },
        connectedUsers: (state) => {
            return state.connectedUsers
        },
        notifications: (state) => {
            return state.notifications
        },
        getInactivState: (state) => {
            return state.inactivState
        },
    },

    mutations: {
        
        updTrackPage(state, payload) {
            let user = state.connectedUsers.find(el => el.uuid === payload.user_id)
            if(user) {
                Vue.set(user, 'isAfk', false)
                Vue.set(user, 'lastpage', payload.path.params)
            }
        },

        updateUser: function(state, elems) {

            var ee = {}
            var list = state.user
            if (elems.keys.length == 2) {
                ee[elems.keys[0]] = {}

                ee[elems.keys[0]][elems.keys[1]] = (elems.value == null) ? '' : elems.value;
                state.user[elems.keys[0]] = {...list[elems.keys[0]], ...ee[elems.keys[0]] };
            } else {
                ee[elems.keys[0]] = (elems.value == null) ? '' : elems.value;
                state.user = {...list, ...ee };
            }



        },

        getConnectedUsers: function(state, elems) {
            if (Array.isArray(elems)) state.presenceSources = { legacy: elems }
            else Vue.set(state.presenceSources, elems.scope, elems.users)
            state.connectedUsers = mergePresence(state.presenceSources)
        },

        leaveUser: function(state, elem) {
            const scope = elem.scope || 'legacy'
            const user = elem.user || elem
            Vue.set(state.presenceSources, scope, (state.presenceSources[scope] || []).filter(p => Number(p.uuid) !== Number(user.uuid)))
            state.connectedUsers = mergePresence(state.presenceSources)
        },
        joinUser: function(state, elem) {
            const scope = elem.scope || 'legacy'
            const user = elem.user || elem
            Vue.set(state.presenceSources, scope, [...(state.presenceSources[scope] || []).filter(p => Number(p.uuid) !== Number(user.uuid)), user])
            state.connectedUsers = mergePresence(state.presenceSources)
        },

        updateUserActivity(state, payload) {
        const user = state.connectedUsers.find(u => u.id === payload.id)
            if (user) {
                Object.assign(user, payload)
            }
        },

        getNotifications(state, payload) {

            state.notifications = state.notifications.filter(el => el.key !== payload.key)
            state.notifications.unshift(payload)
        },
        removeNotifications(state, payload) {
            state.notifications = state.notifications.filter(el => el != payload)
        },

        updateInactivState(state, payload) {
            state.inactivState = payload
        },
    },

    actions: {

        setUser: function({ state }) {
            return new Promise((resolve, reject) => {
                api.get('auth/me', { params: { url: window.location.href } })
                    .then((resp) => {

                        state.user = resp.data.user
                        state.profils = resp.data.profils
                        state.isAuth = true,
                        state.isPublic = resp.data.user.public;
                        env.setTypeDroit(resp.data.user.typedroit);
                        env.setMetier(resp.data.user.metier);
                        env.setIDuser(resp.data.user.id);
                        env.setUIDuser(resp.data.user.uuid);
                        env.setTypeUser(resp.data.user.type);
                        env.setEnv(resp.data.env)


                        resolve(resp.data)
                    }, error => {
                        if (error.response.data.message == 'noconnect') {
                            localStorage.removeItem("tokenMinu");
                            reject(error.response.data.message)
                        }
                    })
            })
        },

        logOut: function( { dispatch, state } ) {

            dispatch('getoverlay', true)
            dispatch('textOverlay', 'déconnexion en cours...');
            api.post('auth/logout').then(() => {
                localStorage.removeItem("tokenMinu");
                state.systemLoad = false;
                state.isAuth = false;
                state.isPublic = false;
                resetRouter();
                state.user = { nickname: '', companie: '', iduser: '', email: '', imgSrc: '', preferences: {} }
                localStorage.removeItem("firstConnect")
                window.location.reload()
                router.push('/login');
                dispatch('getoverlay', false)
            }).catch(()=> {
                localStorage.removeItem("tokenMinu");
                state.systemLoad = false;
                state.isAuth = false;
                state.isPublic = false;
                resetRouter();
                state.user = { nickname: '', companie: '', iduser: '', email: '', imgSrc: '', preferences: {} }
                localStorage.removeItem("firstConnect")
                window.location.reload()
                router.push('/login');
                dispatch('getoverlay', false)
            })



        },

        updateUser: function({ commit }, val) {
            commit('updateUser', val)
        },

        SystemLoaded: function({ state },val) {
            state.systemLoad = val;
        },
        setAuth: function({ state },val) {
            state.isAuth = val;
        },
        getConnectedUsers: function({ commit }, val) {
            commit('getConnectedUsers', val)
        },
        joinUser: function({ commit }, val) {
            commit('joinUser', val)
        },
        leaveUser: function({ commit }, val) {
            commit('leaveUser', val)
        },
        updateUserActivity: function({ commit }, val) {
        commit('updateUserActivity', val)
        },
        updTrackPage: function({ commit }, val) {
        commit('updTrackPage', val)
        },
        getNotifications: function({ commit }, val) {
        commit('getNotifications', val)
        },
        removeNotifications: function({ commit }, val) {
        commit('removeNotifications', val)
        },
        updateInactivState: function({ commit }, val) {
        commit('updateInactivState', val)
        }, 
    }

}
export default getUser;
